import React, { useContext, useRef, useState } from "react";
import { ButtonsActions, NewProjectContext } from "../../pages/newProject";
import GalleryProfile from "../GalleryProfile";
import {
  Box,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro";
import AddIcon from "@mui/icons-material/Add";
import AbcIcon from "@mui/icons-material/Abc";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PercentIcon from "@mui/icons-material/Percent";

function FirstStep() {
  const {
    previewPicture,
    handlerChangePreviewImage,
    newCreateData,
    setNewCreateData,
    showSnack,
    galleryPreview,
    setGalleryPreview,
  } = useContext(NewProjectContext);
  const fileInputPhoto = useRef(null);
  const fileGallery = useRef(null);

  const handlerAddGalleryImage = (e) => {
    if (galleryPreview.length === 10) {
      showSnack("No se pueden agregar más de 10 imágenes");
      return;
    }

    const file = e.target.files[0];

    if (file === undefined) {
      return;
    }

    const reader = new FileReader();
    setNewCreateData({
      ...newCreateData,
      gallery: [...newCreateData.gallery, file],
    });
    reader.onloadend = () => {
      setGalleryPreview([
        ...galleryPreview,
        { url: reader.result, name: file.name },
      ]);
    };
    reader.readAsDataURL(file);
  };

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  const calcDates = (date1, date2) => {
    const initialDate = new Date(date1);
    const finalDate = new Date(date2);

    const tiempo1 = initialDate.getTime();
    const tiempo2 = finalDate.getTime();

    const diferenciaMilisegundos = tiempo2 - tiempo1;

    const milisegundosPorDia = 24 * 60 * 60 * 1000;
    const diferenciaDias = diferenciaMilisegundos / milisegundosPorDia;
    return diferenciaDias;
  };

  return (
    <Stack component="section">
      <Stack
        component="header"
        flexDirection={{ xs: "column", md: "row" }}
        gap={5}
        mb={4}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          component="article"
          sx={{
            boxShadow: previewPicture
              ? {
                  xs: "-3px 4px 8px -1px rgba(0,0,0,0.2)",
                  md: "-3px 5px 8px -1px rgba(0,0,0,0.3)",
                }
              : "none",
            cursor: "pointer",
            width: { xs: "100%", md: "40%" },
            height: { xs: 250, md: 270 },
            border: "1px solid gray",
            borderRadius: 2,
          }}
          onClick={() => fileInputPhoto.current.click()}
        >
          {!!previewPicture ? (
            <img
              width="100%"
              height="100%"
              style={{ objectFit: "cover", borderRadius: 8 }}
              src={previewPicture}
            />
          ) : (
            <AddAPhotoIcon sx={{ color: "#87878757" }} fontSize="large" />
          )}
          <input
            style={{ display: "none" }}
            type="file"
            accept=".jpg, .png, .jpeg, .webp"
            ref={fileInputPhoto}
            onChange={handlerChangePreviewImage}
          />
        </Stack>
        <Stack
          gap={2}
          sx={{
            width: { xs: "100%", md: "60%" },
          }}
        >
          <Stack>
            <Typography component="h3" variant="h6" mb={2}>
              Datos Proyecto
            </Typography>
            <TextField
              label="Nombre del Proyecto"
              required
              value={newCreateData.name}
              onChange={({ target }) => {
                if (target.value.length > 40) {
                  showSnack(
                    "El nombre del proyecto solo puede tener un máximo de 40 caracteres"
                  );
                  return;
                }
                setNewCreateData({ ...newCreateData, name: target.value });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AbcIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Nombre de la Empresa"
              required
              value={newCreateData.name_business}
              onChange={({ target }) => {
                if (target.value.length > 40) {
                  showSnack(
                    "El nombre de la empresa solo puede tener un máximo de 40 caracteres"
                  );
                  return;
                }
                setNewCreateData({
                  ...newCreateData,
                  name_business: target.value,
                });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AbcIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Información del proyecto"
              required
              sx={{ height: "80px" }}
              multiline
              rows={2}
              value={newCreateData.information}
              onChange={({ target }) => {
                if (target.value.length > 730) {
                  showSnack(
                    "La información solo puede tener un máximo de 730 caracteres"
                  );
                  return;
                }
                setNewCreateData({
                  ...newCreateData,
                  information: target.value,
                });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AbcIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Stack>
      </Stack>
      <Stack mb={3}>
        <Typography component="h3" variant="h6" mb={2}>
          General
        </Typography>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          gap={3}
          mb={2}
        >
          <TextField
            label="Inversión"
            required
            type="text"
            value={formatNumberWithDots(newCreateData.objective)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({ ...newCreateData, objective: result });
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Préstamos"
            required
            type="text"
            fullWidth
            value={formatNumberWithDots(newCreateData.loans)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({ ...newCreateData, loans: result });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          mb={2}
          gap={3}
        >
          <TextField
            type="text"
            label="Rentabilidad estimada"
            required
            value={formatNumberWithDots(newCreateData.esti_profitability)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  esti_profitability: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
          <TextField
            label="Inversión Mínima"
            required
            type="text"
            value={formatNumberWithDots(newCreateData.min_investment)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  min_investment: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          gap={3}
        >
          <TextField
            label="Fecha Inicial"
            required
            type="date"
            value={newCreateData.initial_date}
            InputProps={{
              inputProps: {
                min: new Date().toISOString().split("T")[0],
              },
            }}
            onChange={({ target }) => {
              const [initialYear, intialMonth, initialDay] = target.value
                .split("-")
                .map(Number);
              const initialDate = new Date(
                initialYear,
                intialMonth - 1,
                initialDay
              ); // Month is 0-indexed
              initialDate.setHours(0, 0, 0, 0);

              const today = new Date();
              today.setHours(0, 0, 0, 0);

              if (!initialDate >= today) {
                showSnack(
                  "La fecha inicial no puede ser anterior a la fecha actual"
                );
                return;
              }

              setNewCreateData({
                ...newCreateData,
                initial_date: target.value,
              });
            }}
            fullWidth
          />
          <TextField
            label="Fecha Límite"
            required
            type="date"
            value={newCreateData.final_date}
            onChange={({ target }) => {
              const myDate = new Date();

              const currentDate = `${myDate.getFullYear()}-${String(
                myDate.getMonth() + 1
              ).padStart(2, "0")}-${String(myDate.getDate()).padStart(2, "0")}`;

              if (
                currentDate === target.value ||
                target.value === newCreateData.initial_date
              ) {
                showSnack(
                  "Error, las fecha inicial y final no pueden ser iguales."
                );
                return;
              }

              let result = calcDates(newCreateData.initial_date, target.value);

              if (result < 1) {
                showSnack(
                  "Error, la fecha final no puede ser menor a la fecha inicial",
                  "error",
                  5000
                );
                return;
              }

              setNewCreateData({
                ...newCreateData,
                final_date: target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            InputProps={{
              inputProps: {
                min: new Date(new Date().setMonth(new Date().getMonth() + 1))
                  .toISOString()
                  .split("T")[0],
              },
            }}
          />
        </Box>
      </Stack>
      <Stack>
        <Stack flexDirection="row" alignItems="center" mb={2}>
          <Typography component="h3" variant="h6" mr={2}>
            Imágenes del proyecto
          </Typography>
          <IconButton
            onClick={() => fileGallery.current.click()}
            size="small"
            sx={{
              backgroundColor: "primary.main",
              color: "white",
              "&:hover": { backgroundColor: "primary.300" },
            }}
          >
            <AddIcon fontSize="small" />
          </IconButton>

          <input
            onChange={handlerAddGalleryImage}
            style={{ display: "none" }}
            type="file"
            accept=".jpg, .png, .jpeg, .webp"
            ref={fileGallery}
          />
        </Stack>
        <GalleryProfile
          setGalleryImages={setGalleryPreview}
          data={galleryPreview}
          mainData={newCreateData}
          setDataProfile={setNewCreateData}
          type="create"
        />
      </Stack>
      <ButtonsActions />
    </Stack>
  );
}

export default FirstStep;

